import PatchTrendChart from '~/components/guardian/PatchTrendChart'
import ReactController from '~/controllers/react_controller'

export default class PatchManagementTrendChartController extends ReactController {
  static values = {
    accountIds: Array,
    guardianTiers: Array,
    environments: Array,
    url: String,
  }

  createComponent() {
    return (
      <PatchTrendChart
        url={this.urlValue}
        params={{
          query: {
            account_ids: this.accountIdsValue,
            guardian_tiers: this.guardianTiersValue,
            environments: this.environmentsValue,
          },
        }}
      />
    )
  }
}
